const modals = {
    open: [],
    events: {},

    $on(event, callback) {
        if (!this.events[event])
            this.events[event] = [];
        this.events[event].push(callback);
    },
    $off(event, callback) {
        if (!this.events[event])
            return;
        _.pull(this.events[event], callback);
    },
    $emit(event) {
        if (!this.events[event])
            return;
        this.events[event].forEach((callback) => callback());
    },

    $shown(vm) {
        this.open.unshift(vm);

        if (this.open.length === 1)
            attach();

        this.$emit('shown');
    },

    $hidden(vm) {
        _.pull(this.open, vm);

        if (this.open.length === 0)
            detach();

        this.$emit('hidden');
    },
};

function attach() {
    jQuery('body').addClass('body-no-scroll');
    jQuery('body').on('keydown', keydown);
}

function detach() {
    jQuery('body').removeClass('body-no-scroll');
    jQuery('body').off('keydown', keydown);
}

function keydown(event) {
    // Handle escape key when SweetAlert is not open
    if (event.keyCode === 27 && !swal.isVisible()) {
        event.preventDefault();
        modals.open[0].hide();
    }
}

export default {
    install(Vue, options) {
        Vue.prototype.$modals = modals;
    },
};
